module.exports = { "default": require("core-js/library/fn/weak-map"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/core-js/weak-map.js
 ** module id = 742
 ** module chunks = 0
 **/